import React from 'react';
import HeaderComponent from './HeaderComponent';
import FooterComponent from './FooterComponent';
import AddHomeSliderContentComponent from './AddHomeSliderContentComponent';

class AddHomeSliderComponent extends React.Component {
    render() {
        return(
            <div className="main-panel">
                <AddHomeSliderContentComponent location={this.props.location}/>
                <FooterComponent/>
            </div>
        );
    }
}

export default AddHomeSliderComponent;